<template>

    <div class="col-12 mb-3" id="col_likes">
        <div style="white-space: nowrap; padding-bottom: 20px" v-if="clicked == null">
            <span class="pr-2 title-dudas">¿Hemos resuelto tus dudas?</span>
<!--            <img src="/img/logos/Like.svg"  style="width: 15px; padding-bottom: 5px; cursor: pointer" alt="like" class="mr-2" @click="clickLike(true)"></img>-->

            <svg ref="like" id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" style="width: 18px; padding-bottom:  5px; cursor: pointer;" viewBox="0 0 18.53 17.88" @click="clickLike(true)">
                <defs>

                </defs>
                <title>Like</title>
                <path class="cls-1" d="M18.53,8.51c0,.09,0,.18,0,.28l-1,6.48a2.77,2.77,0,0,1-1.19,2.07,3.51,3.51,0,0,1-2,.54H6.55a2.73,2.73,0,0,1-1.8-.69.92.92,0,0,1-.58.21H.91A.9.9,0,0,1,0,16.5V7.61a.91.91,0,0,1,.91-.9H4.17a.9.9,0,0,1,.76.41,5.83,5.83,0,0,0,1.43-.74A3,3,0,0,0,7.76,3.9V.73A.61.61,0,0,1,8.19.15,3.4,3.4,0,0,1,11,.5a3.09,3.09,0,0,1,1.11,2.68V5.86h3.77A2.75,2.75,0,0,1,18.53,8.51Zm-1.22.1v0a1.54,1.54,0,0,0-1.46-1.49H11.47a.61.61,0,0,1-.61-.61V3.18a2,2,0,0,0-.6-1.71A1.89,1.89,0,0,0,9,1.22V3.9A4.18,4.18,0,0,1,7,7.39a6.25,6.25,0,0,1-1.86.92l-.1,0v7.05a.29.29,0,0,1,0,.09,1.49,1.49,0,0,0,1.45,1.2h7.77c1.77,0,1.91-1.16,2-1.55v0ZM3.86,16.2V7.92H1.21V16.2Z"/>
                <rect class="cls-2" x="1.21" y="7.92" width="2.65" height="8.28"/>
            </svg>



<!--            <img src="/img/logos/Like.svg" style="width: 15px; padding-bottom: 0; transform: rotate(180deg); cursor: pointer" alt="dislike" @click="clickLike(false)"></img>-->


            <svg ref="dislike" id="Capa_2" data-name="Capa 2" style="width: 18px; padding-bottom: 0; transform: rotate(180deg); cursor: pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.53 17.88" @click="clickLike(false)">
                <defs>

                </defs>
                <title>Dislike</title>
                <path class="cls-1" d="M18.53,8.51c0,.09,0,.18,0,.28l-1,6.48a2.77,2.77,0,0,1-1.19,2.07,3.51,3.51,0,0,1-2,.54H6.55a2.73,2.73,0,0,1-1.8-.69.92.92,0,0,1-.58.21H.91A.9.9,0,0,1,0,16.5V7.61a.91.91,0,0,1,.91-.9H4.17a.9.9,0,0,1,.76.41,5.83,5.83,0,0,0,1.43-.74A3,3,0,0,0,7.76,3.9V.73A.61.61,0,0,1,8.19.15,3.4,3.4,0,0,1,11,.5a3.09,3.09,0,0,1,1.11,2.68V5.86h3.77A2.75,2.75,0,0,1,18.53,8.51Zm-1.22.1v0a1.54,1.54,0,0,0-1.46-1.49H11.47a.61.61,0,0,1-.61-.61V3.18a2,2,0,0,0-.6-1.71A1.89,1.89,0,0,0,9,1.22V3.9A4.18,4.18,0,0,1,7,7.39a6.25,6.25,0,0,1-1.86.92l-.1,0v7.05a.29.29,0,0,1,0,.09,1.49,1.49,0,0,0,1.45,1.2h7.77c1.77,0,1.91-1.16,2-1.55v0ZM3.86,16.2V7.92H1.21V16.2Z"/>
                <rect class="cls-2" x="1.21" y="7.92" width="2.65" height="8.28"/>
            </svg>
        </div>
        <div v-else style="white-space: nowrap; padding-bottom: 20px">
            <span class="pr-2 font-weight-bold  title-dudas">¡Gracias por tu ayuda!</span>
        </div>
    </div>

</template>

<script>
    import Axios from 'axios';
    import VueCookies from 'vue-cookies'
    export default {
        name: "DudasComponent",
        props: ["section"],
        data: function(){
            return {
                clicked: null,
            }
        },
        methods: {
            clickLike: function (val) {
                var that = this;
                if(val === false){
                    axios.post('/ayuda/like',{
                        slug: that.section,
                        like: val
                    }).then(function(data){
                        var set = { clicked: val };
                        that.clicked = val;
                        $cookies.set(that.section + "_help_cookie", set, Infinity);
                        that.$toasted.success("Voto registrado con éxito");
                    }).catch(function (err) {
                        that.$toasted.error("Error al guardar el voto");
                    });

                }else{
                    axios.post('/ayuda/like',{
                        slug: that.section,
                        like: true
                    }).then(function(data){
                        var set = { clicked: true, slug: that.section };
                        that.clicked = true;
                        $cookies.set(that.section + "_help_cookie", set , Infinity);
                        that.$toasted.success("Voto registrado con éxito");
                    }).catch(function (err) {
                        that.$toasted.error("Error al guardar el voto");
                    });
                }
            }

        },
        watch: {

        },
        computed: {

        },
        mounted() {
            if($cookies.isKey(this.section + "_help_cookie")){
                this.clicked = $cookies.get(this.section + "_help_cookie").clicked;
            }
        }
    }
</script>

<style scoped>

    .title-dudas{
        font-size: 1.15rem;
    }

</style>
